module.exports = __webpack_public_path__ + "fe4848195deab53e22cff90ab237da63.mp3";